/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_NextInputs */

const en_us2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next exercises`)
};

const pt_br2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos exercícios`)
};

const es_419_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguientes ejercicios`)
};

const pt_pt2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios seguintes`)
};

const fr_fr2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices suivants`)
};

const de_de2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Übungen`)
};

const it_it2_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi successivi`)
};

/**
* | output |
* | --- |
* | "Next exercises" |
*
* @param {Today_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_next = /** @type {((inputs?: Today_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_next(inputs)
	if (locale === "es-419") return es_419_today_next(inputs)
	if (locale === "pt-PT") return pt_pt2_today_next(inputs)
	if (locale === "fr-FR") return fr_fr2_today_next(inputs)
	if (locale === "de-DE") return de_de2_today_next(inputs)
	if (locale === "it-IT") return it_it2_today_next(inputs)
	return en_us2_today_next(inputs)
});
export { today_next as "today.next" }